import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const PricedUpBrandIcon = observer(
    'PricedUpBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='32'
            height='32'
            viewBox='0 0 32 32'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g>
                <g>
                    <path
                        d='M5.08507 11.0526V21.062C5.08507 23.6614 6.39742 24.8958 8.404 24.8958C10.4106 24.8958 11.7492 23.7121 11.7492 21.1907V11.0526H16.7929L8.41715 2.93521L0.0413818 11.0526H5.08507Z'
                        fill='#F2C300'
                    />
                    <path
                        d='M24.5383 11.0526L16.7929 11.0526L16.7929 21.0366C16.7929 25.6416 14.6877 28.2062 11.2504 29.0648H21.7849V23.9187H24.2809C28.7318 23.9187 32 21.6801 32 17.4086V17.3569C32 13.3945 29.0663 11.0526 24.5383 11.0526ZM27.0343 17.6397C27.0343 19.0554 25.9277 20.007 24.1785 20.007H21.7859V15.2461H24.1532C25.9286 15.2461 27.0353 16.0437 27.0353 17.588V17.6388L27.0343 17.6397Z'
                        fill='#F2C300'
                    />
                </g>
            </g>
        </SvgElement>
    )
);
